import React from 'react';
import { Star } from 'lucide-react';
import Reveal from './Reveal';

const GoogleLogo = ({ className = 'w-5 h-5' }) => (
  <svg viewBox="0 0 48 48" className={className} aria-label="Google">
    <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z" />
    <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z" />
    <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 35.091 26.715 36 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z" />
    <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303c-.792 2.237-2.231 4.166-4.087 5.571.001-.001.002-.001.003-.002l6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z" />
  </svg>
);

const Stars = () => (
  <div className="flex gap-0.5" aria-label="5 de 5 estrelas">
    {[0, 1, 2, 3, 4].map((i) => (
      <Star key={i} className="w-4 h-4 text-amber-400 fill-amber-400" />
    ))}
  </div>
);

const REVIEWS = [
  {
    name: 'André Alves',
    initials: 'AA',
    color: 'bg-orange-500',
    text: 'Boa tarde. Passando para deixar minha grande satisfação no meu processo seletivo. Após algumas conversas satisfatórias, consegui ser aprovado. Meus sinceros agradecimentos à HM Talent, em especial ao Higor, um excelente recrutador.',
  },
  {
    name: 'Bárbara Amarante',
    initials: 'BA',
    color: 'bg-amber-500',
    text: 'Foi uma entrevista maravilhosa, muito esclarecedora, tratamento muito profissional e humano. O Higor me explicou muito bem a vaga e me trouxe mais interesse em participar do processo seletivo.',
  },
  {
    name: 'Luana Dias',
    initials: 'LD',
    color: 'bg-rose-500',
    text: 'A seleção que o Higor faz é de excelência, ele possui muita assertividade nos perfis, além de ter senso de urgência. Indico de olhos fechados!!',
  },
  {
    name: 'Ana Paula Ramos',
    initials: 'AP',
    color: 'bg-indigo-500',
    text: 'Amei a experiência com a HM Talent! O Higor é um excelente recrutador e profissional. Ele me deixou super à vontade, com perguntas bem alinhadas à minha experiência e à vaga. A condução da conversa foi organizada e clara. Desejo muito sucesso à HM Talent e ao Higor em suas próximas conquistas!',
  },
];

const GoogleReviews = () => {
  return (
    <section data-testid="google-reviews-section" className="section-padding bg-white">
      <div className="container-hm px-6">
        <Reveal className="text-center max-w-2xl mx-auto mb-10">
          <p className="text-sm uppercase tracking-widest text-hm-orange font-bold mb-2">Depoimentos</p>
          <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900">O que dizem sobre a HM Talent</h2>

          <div className="mt-6 inline-flex flex-col sm:flex-row items-center gap-3 bg-slate-50 border border-slate-200 rounded-2xl px-6 py-4 card-shadow">
            <GoogleLogo className="w-8 h-8" />
            <div className="text-left">
              <div className="flex items-center gap-2">
                <span className="text-2xl font-extrabold text-slate-900">5,0</span>
                <Stars />
              </div>
              <p className="text-sm text-slate-600 font-semibold">Empresa avaliada com nota 5,0 no Google</p>
            </div>
          </div>
        </Reveal>

        <div className="grid sm:grid-cols-2 gap-5">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.name} delay={i * 80} variant="fadeUp">
              <div data-testid={`google-review-${i}`} className="h-full bg-white border border-slate-100 rounded-2xl p-6 card-shadow hover-lift">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className={`w-11 h-11 rounded-full ${r.color} text-white flex items-center justify-center font-bold`}>{r.initials}</div>
                    <div>
                      <p className="font-bold text-slate-900 leading-tight">{r.name}</p>
                      <Stars />
                    </div>
                  </div>
                  <GoogleLogo className="w-6 h-6 shrink-0" />
                </div>
                <p className="mt-4 text-slate-700 leading-relaxed text-sm">"{r.text}"</p>
                <div className="mt-4 flex items-center gap-1.5 text-xs text-slate-400 font-medium">
                  <GoogleLogo className="w-3.5 h-3.5" /> Avaliação verificada via Google
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GoogleReviews;
